import React, { ReactNode, useRef } from 'react';
import dynamic from 'next/dynamic';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import { Navbar } from '@mais-retorno-front/components/navbar';
import { Footer } from '@mais-retorno-front/components/footer';
import themeColors from '@mais-retorno-front/theme/theme-variables';
import { AppFooterWithServiceTerms } from '../app/componentes/footer';
import { Breadcrumbs } from '@mais-retorno-front/components/breadcrumbs';
import { IBreadcrumbs } from '@mais-retorno-front/models/breadcrumbs.model';

import { FooterContainer } from './styles';
import { CtaComparisson } from '@mais-retorno-front/modules/comparison/components/cta-comparison';

const GeneralSearch = dynamic(() =>
  import('@mais-retorno-front/components/general-search').then(
    (mod) => mod.GeneralSearch
  )
);

interface DefaultLayoutProps {
  children: ReactNode;
  showFooterServiceTerms?: boolean;
  breadcrumbs: IBreadcrumbs[];
  hiddenGeneralSearch?: boolean;
  showCtaComparisson?: boolean;
  errorInformative?: boolean;
}

export default function DefaultToolsLayout({
  children,
  showFooterServiceTerms = false,
  breadcrumbs,
  hiddenGeneralSearch = false,
  showCtaComparisson = false,
  errorInformative = false,
}: DefaultLayoutProps) {
  const searchAssetsInputRef = useRef<HTMLInputElement>();

  return (
    <>
      <style jsx global>{`
        body {
          background-color: ${themeColors.colors.backgroundColor};
        }

        @media print {
          body {
            background-color: #fff;
          }

          .scrollSpy {
            display: none;
          }

          #sheet-fund-create-simulation {
            display: none;
          }

          #comparison-buton {
            display: none;
          }
        }
      `}</style>
      <Navbar />

      <main className="app">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          {showCtaComparisson && <CtaComparisson />}
        </Stack>

        {!hiddenGeneralSearch && (
          <Box displayPrint="none" style={{ marginBottom: 40 }}>
            <GeneralSearch forwardRef={searchAssetsInputRef} />
          </Box>
        )}

        {children}
      </main>

      {showFooterServiceTerms && (
        <FooterContainer>
          <AppFooterWithServiceTerms />
        </FooterContainer>
      )}

      <Footer />
    </>
  );
}
